module.exports = __webpack_public_path__ + "img/Nicotech.5a1f8e81.svg";